import { useState } from "react";
import { ButtonSubmit } from "../ButtonSubmit";
import InputGlobal from "../InputGlobal";
import { ReactComponent as CloseIcon } from "../../images/close.svg";
import cn from "classnames";
import {
  COOKIE_NAME,
  COOKIE_QUERY_NAME,
  deleteCookie,
  gtmRegistration,
  validatePassword,
  validateName,
  validateEmail,
  POST_REG_FUNNEL_SHOW,
  POST_REG_FUNNEL_SHOW_REQUIRED,
  prepareRegistrationData,
  REGISTRATION_CONFIRMED,
  simplyClick,
} from "../../helpers";
import "./SecondStep.scss";
import { apiRegistration } from "../../services/api";
import Eye from "../../images/eye.svg";
import EyeOff from "../../images/eye-off.svg";
import LoaderEmail from "../LoaderEmail/index";
import { useAppendLandingId } from "../../hooks/useAppendLandingId";
import { EMAIL_ALREADY_USED, landingId } from "../../constant/index";

export const SecondStep = ({ data, setData, nextStep }) => {
  const [checkBox, setCheckBox] = useState(false);
  const [passwordShow, setPasswordShow] = useState(false);
  const [errors, setErrors] = useState({
    name: null,
    email: null,
    password: null,
    terms: null,
    response: null,
    responseEmail: null,
  });

  const [loader, setLoader] = useState(false);
  const [loaderText, setLoaderText] = useState({
    main: "",
    sub: "",
  });

  const [value, setValue] = useState("");
  const [shake, setShake] = useState(false);

  useAppendLandingId(landingId);

  const handleSubmit = async (e) => {
    e.preventDefault();

    let valid = true;

    const { error, status } = validateName(data.first_name);
    if (!status) {
      setErrors((prev) => ({ ...prev, name: error }));
      valid = false;
      if (!data.first_name || data.first_name.trim().length === 0) {
        simplyClick("err_lnd_name_noname");
      } else if (data.first_name.trim().length < 2) {
        simplyClick("err_lnd_name_shortname");
      } else {
        simplyClick("err_lnd_name_symbolname");
      }
    }

    const resultEmail = validateEmail(data.email);
    if (!resultEmail.status) {
      setErrors((prev) => ({ ...prev, email: resultEmail.error }));
      valid = false;
      if (!data.email || data.email.trim().length === 0) {
        simplyClick("err_lnd_email_noemail");
      } else {
        simplyClick("err_lnd_email_wrongemail");
      }
    }

    const resultPassword = validatePassword(data.password);
    if (!resultPassword.status) {
      setErrors((prev) => ({ ...prev, password: resultPassword.error }));
      valid = false;
      if (!data.password || data.password.trim().length === 0) {
        simplyClick("err_lnd_password_nopassword");
      } else {
        simplyClick("err_lnd_password_shortpassword");
      }
    }

    if (!checkBox) {
      setErrors((prev) => ({
        ...prev,
        terms:
          "Please accept our Terms of Use, Privacy Policy, Cookie Policy, Billing & Refund Policy, Consent Policy",
      }));
      simplyClick("err_lnd_checkbox_nocheckbox");
      valid = false;
    }

    if (!valid) {
      return;
    }

    setLoader(true);
    setLoaderText({
      main: "Checking your email...",
      sub: "This might take a moment.",
    });

    const textTimeout = setTimeout(() => {
      setLoaderText({
        main: "Still checking your email...",
        sub: "Thanks for your patience!",
      });
    }, 3000);

    apiRegistration(prepareRegistrationData(data), (response) => {
      clearTimeout(textTimeout);
      setLoader(false);
      setLoaderText({ main: "", sub: "" });

      responseCb(response);
    });

    simplyClick("cl_lnd_qm1_step1_join");
  };

  const responseCb = (response) => {
    setLoader(false);
    if (response.status === 200) {
      const data = JSON.parse(response.responseText);

      if (data.success === true) {
        deleteCookie(COOKIE_QUERY_NAME);
        deleteCookie(COOKIE_NAME);
        gtmRegistration(data.data);

        if (data.data.onModeration === true) {
          window.location.href = "/moderation/";
        } else {
          if (
            data.data.confirmed == REGISTRATION_CONFIRMED &&
            data.data.access_token
          ) {
            if (
              data.data.reg_funnel_status == POST_REG_FUNNEL_SHOW ||
              data.data.reg_funnel_status == POST_REG_FUNNEL_SHOW_REQUIRED
            ) {
              window.location.href = "/wizard/";
            } else {
              window.location.href = "/app/";
            }
          } else {
            window.location.href = "/confirm/";
          }
        }
      }

      return;
    } else if (response.status === 422) {
      const data = JSON.parse(response.responseText);
      let errorText = "";
      data.errors.map((error) => {
        if (error.name === "email") {
          setErrors((prev) => ({
            ...prev,
            responseEmail: error.message,
            email: error.message,
          }));

          const msg = error.message.toLowerCase();

          if (
            msg.includes("already been used") ||
            msg.includes("already exists")
          ) {
            simplyClick("err_lnd_email_againemail");
          } else if (msg.includes("valid email")) {
            simplyClick("err_lnd_email_wrongemail");
          }
        }
      });

      if (errorText !== "") {
        setErrors((prev) => ({ ...prev, response: errorText }));
      }
      return;
    } else if (response.status === 403) {
      window.location.href = "/moderation/";
      return;
    }

    setErrors((prev) => ({
      ...prev,
      response: "Can't register your profile now. Please try again later.",
    }));
  };

  const handleCheckBox = () => {
    setErrors((prev) => ({ ...prev, terms: null }));
    setCheckBox(!checkBox);
    simplyClick("cl_lnd_qm1_join_free_now_checkbox");
  };

  const handleAddPassword = ({ target: { value } }) => {
    setErrors((prev) => ({ ...prev, password: null }));
    setData({ ...data, password: value });
  };

  const handleAddName = ({ target: { value } }) => {
    setErrors((prev) => ({ ...prev, name: null }));
    setData({ ...data, first_name: value });
  };

  const handleAddEmail = ({ target: { value } }) => {
    setEmailValue(value);
    setData({ ...data, email: value });
  };

  const setEmailValue = (value) => {
    setErrors((prev) => ({ ...prev, email: null }));
    setValue(value);
  };

  const setFullEmail = (fullEmail) => {
    setErrors((prev) => ({ ...prev, email: null }));
    setValue(fullEmail);
    setData({ ...data, email: fullEmail });
  };

  const toggleBtn = (e) => {
    e.preventDefault();
    setPasswordShow(!passwordShow);
  };

  const handleFocus = (field) => {
    switch (field) {
      case "name":
        simplyClick("cl_lnd_qm1_start_name");
        break;
      case "email":
        simplyClick("cl_lnd_qm1_start_email");
        break;
      case "password":
        simplyClick("cl_lnd_qm1_start_pass");
        break;
      default:
    }
  };

  return (
    <>
      <main
        className="main__second"
        onClick={(e) => {
          const form = e.currentTarget.querySelector(".second__step-form");
          if (form && !form.contains(e.target)) {
            setShake(true);
            simplyClick("cl_lnd_qm1_photos");
            setTimeout(() => setShake(false), 600);
          }
        }}
      >
        {loader && (
          <LoaderEmail textMain={loaderText.main} textSub={loaderText.sub} />
        )}
        <div className="main__second-wrapper">
          <form
            className={`second__step-form ${shake ? "shake" : ""}`}
            onSubmit={handleSubmit}
            autoComplete="on"
          >
            <span
              onClick={() => {
                simplyClick("cl_lnd_qm1_join_free_close");
                nextStep();
              }}
              className="close"
            >
              <CloseIcon />
            </span>
            <div className="second__step-form-box">
              <h2 className="second__form-title">Join free now</h2>
              <div className="inputs__wrapper">
                <div
                  className="name__wrapper input-tooltip-wrapper"
                  style={{ position: "relative" }}
                >
                  <span className="label">First name</span>
                  <InputGlobal
                    className={cn("input__global", { error: errors.name })}
                    onChange={handleAddName}
                    onFocus={() => handleFocus("name")}
                    name={"name"}
                    placeholder={"Type your name"}
                    value={data.first_name || ""}
                    type={"name"}
                    autocomplete="name"
                  />
                </div>
                {errors.name && <p className="error-text">{errors.name}</p>}

                <div
                  className="email__wrapper input-tooltip-wrapper"
                  style={{ position: "relative" }}
                >
                  <span className="label">Email</span>
                  <InputGlobal
                    className={cn("input__global", { error: errors.email })}
                    onChange={handleAddEmail}
                    onFocus={() => handleFocus("email")}
                    name={"email"}
                    placeholder={"Type your email"}
                    type={"email"}
                    value={data.email || ""}
                    autocomplete="email"
                  />
                </div>
                {errors.email && <p className="error-text">{errors.email}</p>}
                <div
                  className="password__wrapper input-tooltip-wrapper"
                  style={{ position: "relative" }}
                >
                  <span className="label">Password</span>
                  <InputGlobal
                    className={cn("input__global", { error: errors.password })}
                    onChange={handleAddPassword}
                    onFocus={() => handleFocus("password")}
                    name={"password"}
                    placeholder={"Create your password"}
                    type={passwordShow ? "text" : "password"}
                    value={data.password || ""}
                  />

                  <button onClick={toggleBtn} className="logo__eye">
                    {passwordShow ? (
                      <img src={Eye} alt="icon" />
                    ) : (
                      <img src={EyeOff} alt="icon" />
                    )}
                  </button>
                </div>
                {errors.password && (
                  <p className="error-text">{errors.password}</p>
                )}
                {errors.response && (
                  <p className="error-text">{errors.response}</p>
                )}
                <span className="border"></span>
                <div className="terms__wrapper">
                  <input
                    checked={checkBox}
                    onChange={(e) => handleCheckBox(e)}
                    type="checkbox"
                    id="remember_me"
                    className={cn("checkBox", { error: errors.terms })}
                    name="remember"
                    value="1"
                  />
                  <label htmlFor="remember_me" className="checkbox-text">
                    <span> I have read, understand and agree to&nbsp;</span>
                    <span>
                      <a href="/terms-of-use/" target="_blank">
                        Terms of Use
                      </a>
                      ,&nbsp;
                      <a href="/privacy-policy/" target="_blank">
                        Privacy Policy
                      </a>
                      ,&nbsp;
                      <a href="/cookie-policy/" target="_blank">
                        Cookie policy
                      </a>
                      ,&nbsp;
                      <a href="/billing-policy/" target="_blank">
                        Billing
                      </a>
                      &nbsp;&&nbsp;
                      <a href="/refund-policy/" target="_blank">
                        Refund Policy
                      </a>
                      ,&nbsp;
                      <a href="/consent-policy/" target="_blank">
                        Consent Policy
                      </a>
                    </span>
                  </label>
                </div>
                {errors.terms && (
                  <p className="error-text terms-error">{errors.terms}</p>
                )}
                {errors.email === EMAIL_ALREADY_USED && (
                  <div className="extra-info">
                    <p>
                      <a
                        href={`/login/?landing_id=${landingId}${
                          data?.email
                            ? `&email=${encodeURIComponent(data.email)}`
                            : ""
                        }`}
                        onClick={() =>
                          simplyClick("cl_lnd_qm1_againemail_login")
                        }
                      >
                        Log in{" "}
                      </a>
                      or use a different one.
                    </p>
                  </div>
                )}
                <ButtonSubmit
                  className={"button__global button__second"}
                  text="Join now"
                />
              </div>
            </div>
          </form>
        </div>
      </main>
    </>
  );
};
